module.exports = __webpack_public_path__ + "img/dark_willow.1444f6bb.png";